export const GET_AMMUNITION_PENDING = "GET_AMMUNITION_PENDING";
export const GET_MORE_AMMUNITION_PENDING = "GET_MORE_AMMUNITION_PENDING";
export const GET_AMMUNITION_SUCCESS = "GET_AMMUNITION_SUCCESS";
export const GET_MORE_AMMUNITION_SUCCESS = "GET_MORE_AMMUNITION_SUCCESS";
export const RESET_AMMUNITION = "RESET_AMMUNITION";
export const GET_AMMUNITION_DETAILS = "GET_AMMUNITION_DETAILS";
export const RESET_AMMUNITION_DETAILS = "RESET_AMMUNITION_DETAILS";
